module.exports = __webpack_public_path__ + "img/hr-centrifuge-C-shadow.4866aa5a.png";